import { styled, Box, Paper, Typography, Button } from '../../../base';

export const MenuWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingInline: theme.spacing(2),
}));

export const HeaderWrapper = styled(Box)(({ theme }) => ({
    paddingTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '40px',
    flexShrink: 0,
}));

export const CompanySelectWrapper = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
}));

export const CategoriesListWrapper = styled(Box)(({ theme }) => ({
    flexGrow: 1,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    paddingInlineEnd: theme.spacing(0.5),

    '&::-webkit-scrollbar': {
        width: '6px',
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,0.2)',
        borderRadius: '3px',
    },
}));

export const CategoryItemStyled = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1.5, 2),
    cursor: 'pointer',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    transition: 'box-shadow 0.3s',
    '&:hover': {
        boxShadow: theme.shadows[2],
    },
    flexShrink: 0,
}));

export const CategoryContentWrapper = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});

export const PercentageCircleStyled = styled(Box)({
    width: '48px',
    height: '48px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const PercentageText = styled(Typography)(({ theme }) => ({
    position: 'absolute',
    fontSize: '0.8rem',
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
}));

export const CategoryName = styled(Typography)(({ theme }) => ({
    flexGrow: 1,
    marginInlineEnd: theme.spacing(0.5),
}));

export const FooterLinkWrapper = styled(Box)(({ theme }) => ({
    marginTop: 'auto',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    textAlign: 'start',
}));

export const FooterButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    textDecoration: 'underline',
    fontWeight: theme.typography.fontWeightRegular,
    padding: theme.spacing(0.5, 0),
}));
